// Third Party Imports
import React, {Component} from 'react';

// Relative Imports
import '../../utils.less';

class ListingPageAll extends Component {
    constructor(props) {
        super(props);

        this.loaded = false;
        this.state = {};
    }

    componentDidMount() {
        this.loaded = true;
    }

    componentDidUpdate() {
        /**
         * Prefetch correct ListingPage bundle first and then do re-rendering
         * Prevents screen to go blank and preserves scroll position
         */
        const {system} = this.props;
        const {isMobile, useListingPageLite} = system;

        if (isMobile && useListingPageLite && !this.ListingPageMobileLite) {
            import('../ListingPage/ListingPageMobileLite').then((component) => {
                this.ListingPageMobileLite = component.default;
                this.setState({mobileLiteLoaded: true});
            });
        }
        if (isMobile && !useListingPageLite && !this.ListingPageMobile) {
            import('../ListingPage/ListingPageMobile').then((component) => {
                this.ListingPageMobile = component.default;
                this.setState({mobileLoaded: true});
            });
        }
        if (isMobile === false && !this.ListingPageDesktop) {
            import('../ListingPage/ListingPageDesktop').then((component) => {
                this.ListingPageDesktop = component.default;
                this.setState({desktopLoaded: true});
            });
        }
    }

    // eslint-disable-next-line complexity
    render() {
        const {listingPageComponent: ListingPageComponent, ...rest} = this.props;
        const {system} = rest;
        const {isMobile, useListingPageLite} = system;
        const {ListingPageMobile, ListingPageMobileLite, ListingPageDesktop} = this;

        if (
            !this.loaded ||
            (isMobile && useListingPageLite && !this.state.mobileLiteLoaded) ||
            (isMobile && !useListingPageLite && !this.state.mobileLoaded) ||
            (!isMobile && !this.state.desktopLoaded)
        ) {
            return <ListingPageComponent {...rest} />;
        }

        return (
            (isMobile && useListingPageLite && <ListingPageMobileLite {...rest} />) ||
            (isMobile && <ListingPageMobile {...rest} />) || <ListingPageDesktop {...rest} />
        );
    }
}

export default ListingPageAll;
